import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";
import parse from "html-react-parser";

export default () => {//this component contains important text record
    let IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails
    return (
        <div className="importance_text_div">
            <div className="row">
                <div className="col-sm-9">{IV1_PageDetails.ImportantNoticeText ?
                    <>
                    <b>IMPORTANT NOTICE : </b>{parse(IV1_PageDetails.ImportantNoticeText)} <br/><br/>
                    </> : "" }
                    {IV1_PageDetails.DifficultAccessExceptionText ?
                        <>
                     <b>{IV1_PageDetails.DifficultAccessHeader} : </b>
                     {parse(IV1_PageDetails.DifficultAccessExceptionText)}
                        </> : "" }
                    {IV1_PageDetails.shipmentSetting ?
                        <>
                            <b>SHIPMENT TEXT : </b>
                            {IV1_PageDetails.ShipmentText1 ?
                                <>{IV1_PageDetails.ShipmentText1}</> : ""
                            }
                        </> : "" }
                    </div>
                <div className="col-sm-3 info_div">
                    {
                        IV1_PageDetails.Currency && IV1_PageDetails.ArticlePrice ?
                            <>
                            <div className = "texas-text">
                                The customer hereby releases the entire shipment to a value not exceeding.
                                <br/>
                                <div className="col-auto">
                                    <div className="input-group mb-2">
                                        <div className="input-group-prepend">
                                            <div
                                                className="input-group-text">
                                                {IV1_PageDetails.Currency ? IV1_PageDetails.Currency : "$"}</div>
                                        </div>
                                        <input type="text" className="form-control " id="inlineFormInputGroup"
                                           placeholder={IV1_PageDetails.ArticlePrice ?
                                               IV1_PageDetails.ArticlePrice : "0.00"}
                                               disabled/>
                                    </div>
                                </div>
                                {IV1_PageDetails.PricePerPoundPerArticleText}
                                <br/>(Unless otherwise specified)
                            </div>
                            </>

                            :
                            <div className="texas-text">
                                {IV1_PageDetails.ShipmentText}
                            </div>

                    }
                    <br/>
                    {IV1_PageDetails.bol_type === 'Default BOL' ?
                        <>
                        <div className="texas-text">
                            {IV1_PageDetails.NoticeText ?
                                <>
                                    <b>Notice : </b>
                                    {IV1_PageDetails.NoticeText}
                                </>
                                :
                                ""
                            }
                            <br/><br/>
                            {IV1_PageDetails.IfStorageAccountAccess === false ?
                                IV1_PageDetails.StorageAccountAccess
                                :
                                <>
                                    <b>STORAGE ACCOUNTS ACCESS:</b>
                                    <br/>MINIMUM 24 HOUR NOTICE<br/>ACCESS FEES WILL APPLY
                                </>
                            }
                        </div>
                        </>
                        :
                        ""
                    }
                    {IV1_PageDetails.bol_type === 'Texas BOL' ?
                        <>
                            <div className="row-md texas-text">
                                {IV1_PageDetails.TXDMVTEXT1 ?
                                    <>
                                        {IV1_PageDetails.TXDMVTEXT1}
                                    </>
                                    :
                                    ""
                                }
                            </div>
                            <br/>
                            <div className="row-md texas-sign1 texas-text">
                                {
                                    IV1_PageDetails.CustomerSignTexas1.Signature ?
                                        <>
                                            <Signature heading={"CUSTOMER SIGNATURE"}
                                                       image={IV1_PageDetails.CustomerSignTexas1.Signature}
                                                       date={IV1_PageDetails.CustomerSignTexas1.UpdatedAt} />
                                        </>
                                        :
                                        ""
                                }
                            </div>

                            <br/>
                            <div className="row-md texas-text">
                                {
                                    IV1_PageDetails.TXDMVTEXT2 ?
                                        IV1_PageDetails.TXDMVTEXT2
                                        :
                                        ""
                                }
                            </div>
                            <div className="row-md texas-sign2 texas-text">
                                {
                                    IV1_PageDetails.CustomerSignTexas1.Signature ?
                                        <>
                                            <Signature heading={"CUSTOMER SIGNATURE"}
                                                       image={IV1_PageDetails.CustomerSignTexas2.Signature}
                                                       date={IV1_PageDetails.CustomerSignTexas2.UpdatedAt} />
                                        </>
                                        :
                                        ""
                                }
                            </div>
                        </>
                        :
                        ""
                    }

                </div>
            </div>
        </div>
    )
}
const Signature = (props) =>{
    return(
        <>
            <p className="sign_1_headings ">{props.heading}</p>
            <br/>
            <img src={props.image} className="img-rounded sign_1_image"/>
            <br/>
            <p className="sign_1_date"> {props.date}</p>
        </>
    )
}